import React from 'react';
import {
  Select
  , FormHelperText
  , FormControl
  , GridSize
  , Grid
} from '@material-ui/core';

import ErrorIcon from '@material-ui/icons/Error';
import { connect, useDispatch, useSelector } from 'react-redux';
import { change, getFormValues } from 'redux-form';
import slice from '../states/shell/slice';
import useStyles from '../styles/styles';
import { makeStyles } from '@material-ui/core/styles';
import { formName } from '../thunks/constants';
import State from '../states/State';

const useCustomStyles = makeStyles(theme => ({
  PeSelectBox_control: {
    // margin: '20px 0 40px 0',
    // display: 'block',
    padding: theme.spacing(2),
  },
}));


type PeSelectBoxProps = {
  readonly input?: any,
  readonly type: string,
  readonly id: string,
  readonly label: string,
  readonly options: any,
  readonly source?: string,
  readonly required?: boolean,
  readonly sm?: GridSize,
  readonly meta?: {
    touched: any,
    error: any
  },
  readonly formValues: any,
}

const PeSelectBox: React.FC<PeSelectBoxProps> = ({ input, id, sm, meta, label, options, source, required, formValues }) => {
  const classes = useStyles();
  const classesCustom = useCustomStyles();
  const dispatch = useDispatch();
  const state = useSelector((state: State) => ({
    shell: state.shell,
  }));

  const shell = state.shell;

  const getOptionsFromState = () => {
    switch (source) {
      case 'leadSource': return shell.leadSource;
      default: return [];
    }
  }

  const optSource = source ? getOptionsFromState() : options;

  const handleSelect = (event: any) => {
    // set current value to field
    dispatch(change(formName, input.name, event.target.value));
    // set target scroll
    dispatch(slice.actions.updateScrollTarget(input.name));
  }

  return <Grid id={id} container spacing={2}>
    <Grid item sm={sm ? sm : 6}>
      <FormControl error={Boolean(meta?.error)} variant="outlined" fullWidth className={classesCustom.PeSelectBox_control}>
        <input type="hidden" {...input}></input>
        <h3 className={classes.label}>{required && <span className={classes.required}>*</span>}&nbsp;{label}</h3>
        <Select native id="where_hear_us" onChange={handleSelect} value={typeof formValues !== 'undefined' ? formValues[input.name] : ""}>
          {optSource.map((option: any, index: number) => {
            return (
              <option key={index} value={option.value}>
                {option.label}
              </option>
            );
          })}
        </Select>
        {meta?.error && <FormHelperText className={classes.helpText} component="div">
          <ErrorIcon fontSize="small" />
          <p style={{ margin: 0, padding: 0 }}>&nbsp;{meta?.error}</p>
        </FormHelperText>}
      </FormControl>
    </Grid>
  </Grid>
}

export default connect(state => ({
  formValues: getFormValues(formName)(state)
}))(PeSelectBox);